import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body, Text } from './styles';
export const TextPreviewItem = ({ color, firstLine, fontSizeRatio = 1, fontStyle, rotation = 0, scale = 1, secondLine, xOffset, yOffset, warning = false, }) => {
    return (_jsxs(Body, { color: color, fontSizeRatio: fontSizeRatio, fontStyle: fontStyle, style: {
            left: xOffset,
            top: yOffset,
            transform: `translate(-50%, -50%) rotateZ(${rotation}deg) scale(${scale})`,
        }, "$warning": warning, children: [_jsx(Text, { children: firstLine }), secondLine && _jsx(Text, { children: secondLine })] }));
};
//# sourceMappingURL=TextPreviewItem.js.map